

































import { defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import { AgeVerificationStatus } from "@scrile/api-provider/dist/api/AgeVerificationProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { QuickTip } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import ModalView from "@/components/ModalView";
import QuickTipsItem from "@/components/ui/QuickTipsItem";

export default defineComponent({
  name: "AgeVerificationSetup",
  components: { BaseButton, BaseIcon, QuickTipsItem, ModalView },
  props: {
    processing: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const loading = ref(false);
    const yotiUrl = ref("");

    const quickTip: QuickTip = {
      icon: "msr-info",
      text: $t("You must be 18+ to access restricted content."),
    };

    const onSubmit = async () => {
      try {
        loading.value = true;
        yotiUrl.value = await providers.YotiAgeVerificationProvider.start({
          data: {
            successUrl: new URL("/yoti/age-verification/success.html", location.origin).toString(),
            cancelUrl: new URL("/yoti/age-verification/cancel.html", location.origin).toString(),
          },
        });
        emit("update:status", AgeVerificationStatus.PENDING);
      } finally {
        loading.value = false;
      }
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    window.YotiAgeVerificationCallback = {
      onCancel: () => emit("reset"),
      onFinish: () => emit("finish"),
    };

    onBeforeUnmount(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      delete window.YotiAgeVerificationCallback;
    });

    return {
      quickTip,
      loading,
      yotiUrl,
      onSubmit,
    };
  },
});
